import React from 'react';
import Styles from './terms-conditions-styles.scss';
import Checkbox from './KVcheck-box';
import { signUpState } from '../atoms';
import { useRecoilState } from 'recoil';
const TermsConditions = () => {
    const [state, setState] = useRecoilState(signUpState);
    return (React.createElement("div", { className: Styles.wrapper, "data-testid": "terms-conditions" },
        React.createElement(Checkbox, { defaultChecked: state.confirmTerms, onChange: e => setState(prev => (Object.assign(Object.assign({}, prev), { confirmTerms: e }))) }),
        React.createElement("label", { id: "checkbox-label", className: Styles.checkboxLabel }, "I confirm that I am over the age of 13 and agree to the"),
        ' ',
        React.createElement("a", { href: "https://www.kidvestors.co/legal", target: "_blank", rel: "noopener noreferrer", className: Styles.link }, "Terms & Conditions"),
        React.createElement("span", { style: {
                margin: '0 5px'
            } },
            "and",
            ' '),
        React.createElement("a", { href: "https://www.kidvestors.co/privacypolicy", target: "_blank", rel: "noopener noreferrer", className: Styles.link }, "Privacy Policy")));
};
export default TermsConditions;
